// @ts-nocheck
import ReservationApi from "./ReservationApi";

const MOCK_API_DELAY = 1000;

class MockReservationApi implements ReservationApi {
  
  createReservation = () => {

    return new Promise(resolve => {
      const response = {
                          "status": "success",
                          "data": {
                              "reservation": 432504,
                              "price": "304.00",
                              "smEventId": "b071ecd0-ae60-48fc-9324-cd285c4b5adf"
                          }
                      };
      setTimeout(() => resolve(response), MOCK_API_DELAY);
    });
  }; 

}

export default MockReservationApi;
